import {CodeDesignation} from 'sigale-angular';

export class OccupationBureauDto {
	duree: CodeDesignation;
	nomOccupant: string;
	prenomOccupant: string;
	loginOccupant: string;
	estUtilisateurPreferentiel: boolean;

	constructor(duree?: CodeDesignation) {
		if (duree) {
			this.duree = duree;
		}
	}

	deserialize(input: any): OccupationBureauDto {
		Object.assign(this, input);
		return this;
	}

	prenomNomOccupant(): string {
		return this.prenomOccupant + ' ' + this.nomOccupant;
	}
}
